import './xlr8Ascii.css';

function xlr8Ascii() {
  return (
    <div>
      <pre className="ascii-art">
        {`
 ##  ##   ####     ######    ####   
 ##  ##    ##       ##  ##  ##  ##  
  ####     ##       ##  ##  ##  ##  
   ##      ##       #####    ####   
  ####     ##   #   ## ##   ##  ##  
 ##  ##    ##  ##   ##  ##  ##  ##  
 ##  ##   #######  #### ##   ####   
        `}
      </pre>
    </div>
  );
}

export default xlr8Ascii;